import { styled } from 'baseui'

export const Placeholder = styled('div', {
  padding: '1rem',
  color: '#6B7280',
  fontWeight: 600,
})

export const PageContainer = styled('div', {
  width: '100%',
  boxSizing: 'border-box',
  padding: '1rem',
})

export const LayoutCard = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '1rem',
  boxShadow: '0 0.625rem 1.75rem rgba(0,0,0,0.08)',
  display: 'grid',
  gridTemplateColumns: '16.25rem 1fr',
  gap: '1rem',
  padding: '1rem',
  alignItems: 'start',
})

export const ContentArea = styled('main', {
  minWidth: 0,
})

export const SidebarCard = styled('aside', {
  backgroundColor: '#fff',
  borderRadius: '0.875rem',
  border: '0.0625rem solid #E6EAF2',
  padding: '0.75rem',
  boxSizing: 'border-box',
})

export const SidebarItemButton = styled('button', props => {
  const { $active } = props
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
    padding: '0.65rem 0.75rem',
    borderRadius: '0.75rem',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    fontWeight: 700,
    color: '#111827',
    backgroundColor: $active ? '#EEF2FF' : 'transparent',
  }
})

export const SidebarIconContainer = styled('div', props => {
  const { $active } = props
  return {
    width: '1.875rem',
    height: '1.875rem',
    borderRadius: '0.625rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0.0625rem solid #E6EAF2',
    backgroundColor: $active ? '#E0E7FF' : '#F9FAFB',
    flexShrink: 0,
  }
})
